// extracted by mini-css-extract-plugin
export default {"container":"page_container___jxSX","blocks":"page_blocks__1ahmE"};